// src/hooks/usePreventZoom.js

import { useEffect } from 'react';

export function usePreventZoom() {
  useEffect(() => {
    const preventGesture = (event) => {
      event.preventDefault();
    };

    document.addEventListener('gesturestart', preventGesture, {
      passive: false,
    });

    document.addEventListener('gesturechange', preventGesture, {
      passive: false,
    });

    document.addEventListener('gestureend', preventGesture, {
      passive: false,
    });

    return () => {
      document.removeEventListener('gesturestart', preventGesture);
      document.removeEventListener('gesturechange', preventGesture);
      document.removeEventListener('gestureend', preventGesture);
    };
  }, []);
}